import { LibraryImage } from "./libraryimage";
import { LibraryVideo } from "./libraryvideo";
import { LibrarySound } from "./librarysound";
import { LibraryFont } from "./libraryfont";

export class Library {
  images: LibraryImage[];
  videos: LibraryVideo[];
  sounds: LibrarySound[];
  fonts: LibraryFont[];

  constructor(library: Library = null) {
    if (library == null) {
      this.images = [];
      this.videos = [];
      this.sounds = [];
      this.fonts = [];
    } else {
      this.images = [];
      if (library.images) {
        library.images.forEach(image => {
          let newImage = new LibraryImage(image);
          this.images.push(newImage);
        });
      }
      this.videos = [];
      if (library.videos) {
        library.videos.forEach(video => {
          let newVideo = new LibraryVideo(video);
          this.videos.push(newVideo);
        });
      }
      this.sounds = [];
      if (library.sounds) {
        library.sounds.forEach(sound => {
          let newSound = new LibrarySound(sound);
          this.sounds.push(newSound);
        });
      }
      this.fonts = [];
      if (library.fonts) {
        library.fonts.forEach(font => {
          let newFont = new LibraryFont(font);
          this.fonts.push(newFont);
        });
      }
    }
  }

  checkImageNameInUse(name: string, exceptImage: LibraryImage = null): boolean {
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i] != exceptImage && this.images[i].name == name) {
        return true;
      }
    }
    return false;
  }

  getImage(name: string): LibraryImage {
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i].name == name) {
        return this.images[i];
      }
    }
    return null;
  }

  checkVideoNameInUse(name: string, exceptVideo: LibraryVideo = null): boolean {
    for (let i = 0; i < this.videos.length; i++) {
      if (this.videos[i] != exceptVideo && this.videos[i].name == name) {
        return true;
      }
    }
    return false;
  }

  getVideo(name: string): LibraryVideo {
    for (let i = 0; i < this.videos.length; i++) {
      if (this.videos[i].name == name) {
        return this.videos[i];
      }
    }
    return null;
  }

  checkSoundNameInUse(name: string, exceptSound: LibraryImage = null): boolean {
    for (let i = 0; i < this.sounds.length; i++) {
      if (this.sounds[i] != exceptSound && this.sounds[i].name == name) {
        return true;
      }
    }
    return false;
  }

  getSound(name: string): LibrarySound {
    for (let i = 0; i < this.sounds.length; i++) {
      if (this.sounds[i].name == name) {
        return this.sounds[i];
      }
    }
    return null;
  }

  checkFontNameInUse(name: string, exceptFont: LibraryImage = null): boolean {
    for (let i = 0; i < this.fonts.length; i++) {
      if (this.fonts[i] != exceptFont && this.fonts[i].name == name) {
        return true;
      }
    }
    return false;
  }

  getFont(name: string): LibraryFont {
    for (let i = 0; i < this.fonts.length; i++) {
      if (this.fonts[i].name == name) {
        return this.fonts[i];
      }
    }
    return null;
  }
}
